//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { SortDir } from '@apis/campaign-requests/shared/Sorting';
import ClientId from '@models/ClientId';

export enum CategorySortCriteria {
  Name = 'name',
}

export interface GetSamplingCategoriesRequest {
  active?: boolean;
  limit?: number;
  offset?: number;
  retailerId?: ClientId;
  searchText?: string;
  sortCriteria?: CategorySortCriteria;
  sortDirection?: SortDir;
}

export interface SamplingCategory {
  active?: boolean;
  enabled?: boolean;
  externalID?: string;
  hierarchy?: string[];
  name?: string;
}

export interface SamplingCategoriesResponse {
  categories?: SamplingCategory[];
  count?: number;
  limit?: number;
  total?: number;
}
